import { ISelectedGroup, TTypeOfModalWindow } from './styleContext';
import {
	TLanguageIDs,
	IStyleSettings,
	ICustomMediaSettingsForUpdate,
	ICustomDocumentSettingsForUpdate,
	IStyleSettingColors,
} from 'types';

export enum StyleActionsTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	SET_ALL_DATA = 'SET_ALL_DATA',
	SET_STYLE_SETTINGS = 'SET_STYLE_SETTINGS',
	SET_MEDIA_SETTINGS = 'SET_MEDIA_SETTINGS',
	SET_GROUP = 'SET_GROUP',
	SET_LANGUAGE = 'SET_LANGUAGE',
	ADD_GROUP_FOR_LOADER = 'ADD_GROUP_FOR_LOADER',
	REMOVE_GROUP_FOR_LOADER = 'REMOVE_GROUP_FOR_LOADER',
	CHANGE_DOCUMENT_SETTINGS_FOR_UPDATE = 'CHANGE_DOCUMENT_SETTINGS_FOR_UPDATE',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface IRefetchData {
	type: StyleActionsTypes.REFETCH_DATA;
	payload: {
		needRefetch: boolean;
	};
}

interface ISetData {
	type: StyleActionsTypes.SET_ALL_DATA;
	payload: {
		styleSettingColors: IStyleSettingColors;
		mediaSettingsForUpdate: ICustomMediaSettingsForUpdate[];
		documentSettingsForUpdate: ICustomDocumentSettingsForUpdate[];
	};
}

interface ISetStyleSettings {
	type: StyleActionsTypes.SET_STYLE_SETTINGS;
	payload: {
		styleSettings: IStyleSettings[];
	};
}

interface ISetMediaSettings {
	type: StyleActionsTypes.SET_MEDIA_SETTINGS;
	payload: {
		mediaSettingsForUpdate: ICustomMediaSettingsForUpdate[];
	};
}

interface ISetGroup {
	type: StyleActionsTypes.SET_GROUP;
	payload: {
		group: ISelectedGroup;
	};
}

interface ISetLanguage {
	type: StyleActionsTypes.SET_LANGUAGE;
	payload: {
		language: TLanguageIDs;
	};
}

interface IAddGroupForLoader {
	type: StyleActionsTypes.ADD_GROUP_FOR_LOADER;
	payload: {
		updatedLoaders: string[];
	};
}

interface IRemoveGroupForLoader {
	type: StyleActionsTypes.REMOVE_GROUP_FOR_LOADER;
	payload: {
		updatedLoaders: string[];
	};
}

interface IChangeDocumentSettingsForUpdate {
	type: StyleActionsTypes.CHANGE_DOCUMENT_SETTINGS_FOR_UPDATE;
	payload: {
		documentSettingsForUpdate: ICustomDocumentSettingsForUpdate[];
	};
}

interface IChangeTypeOfModalWindow {
	type: StyleActionsTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfModalWindow;
	};
}

export type TStyleAction =
	| IRefetchData
	| ISetData
	| ISetStyleSettings
	| ISetMediaSettings
	| ISetGroup
	| ISetLanguage
	| IAddGroupForLoader
	| IRemoveGroupForLoader
	| IChangeDocumentSettingsForUpdate
	| IChangeTypeOfModalWindow;
